export const getPasswordValidation = password => {
  if (typeof password !== 'string') {
    return { isValid: false, issues: ['Password must be a string'] };
  }

  const issues = [];

  const forbiddenChars = /[<>{}();'"`]/;
  if (forbiddenChars.test(password)) {
    issues.push('Password contains forbidden characters like <, >, {, } or quotes');
  }

  if (password.length < 8) {
    issues.push('Password must be at least 8 characters long');
  }

  if (!/[A-Z]/.test(password)) {
    issues.push('Password must contain at least one uppercase letter');
  }

  if (!/\d/.test(password)) {
    issues.push('Password must contain at least one number');
  }

  if (!/[!@#$%^&*()[\]{}\-_=+|;:,./?~]/.test(password)) {
    issues.push('Password must contain at least one special character');
  }

  return {
    isValid: issues.length === 0,
    issues,
  };
};

export const isValidPassword = password => getPasswordValidation(password).isValid;
export const isValidEmail = email => Boolean(email.match(/^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$/));
